import styled from 'styled-components'
import { MenuOutlined } from '@ant-design/icons'

export const MobileMenuIcon = styled(MenuOutlined)`
  font-size: 40px;
  color: white;
`
